module.exports = __webpack_public_path__ + "static/media/ky.9f7aa589.png";